import { render, staticRenderFns } from "./WalletOpenButton.vue?vue&type=template&id=b1dcf72e&scoped=true"
import script from "./WalletOpenButton.vue?vue&type=script&lang=js"
export * from "./WalletOpenButton.vue?vue&type=script&lang=js"
import style0 from "./WalletOpenButton.vue?vue&type=style&index=0&id=b1dcf72e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1dcf72e",
  null
  
)

export default component.exports